// extracted by mini-css-extract-plugin
export var content = "_o8-1";
export var noScroll = "_o8-3";
export var paper = "_o8-0";
export var scrollable = "_o8-2";